import { useInRouterContext, useNavigate } from "react-router-dom";
import { InformationCircleIcon } from "@heroicons/react/24/outline";

const TROUBLESHOOTING_PATH = "/settings/troubleshooting";

function IndicatorButton({ onClick }: { onClick: () => void }) {
  return (
    <button
      onClick={onClick}
      title="Live streaming is unavailable. Stories are updating via periodic polling instead. Click for troubleshooting info."
      className="group relative flex items-center gap-1 px-1.5 py-0.5 no-drag cursor-pointer text-amber-600 dark:text-amber-400 hover:text-amber-700 dark:hover:text-amber-300 transition-colors"
    >
      <span className="text-2xs font-medium">Polling</span>
      <InformationCircleIcon className="size-3" />
    </button>
  );
}

// Inside the app's <BrowserRouter> (docked widgets): client-side SPA navigation.
function RouterIndicator() {
  const navigate = useNavigate();
  return <IndicatorButton onClick={() => navigate(TROUBLESHOOTING_PATH)} />;
}

// No Router context — e.g. popped-out widget windows, whose subtree is portaled
// outside the app's <BrowserRouter> (PopoutWidgets renders outside <Router>).
// Calling useNavigate() there throws "may be used only in the context of a
// <Router>" and crashes the whole app (Sentry NEWSQUAWK-PORTALS-R8), so navigate
// the app window directly instead.
function RouterlessIndicator() {
  return (
    <IndicatorButton onClick={() => window.location.assign(TROUBLESHOOTING_PATH)} />
  );
}

function PollingModeIndicator() {
  // useInRouterContext() is a safe, non-throwing check — unlike useNavigate(),
  // which throws when no Router is present. Pick the render path accordingly.
  return useInRouterContext() ? <RouterIndicator /> : <RouterlessIndicator />;
}

export default PollingModeIndicator;
